import { BookJsonLdData } from './jsonLdTypes'

/**
 * Generates JSON-LD structured data for book product pages
 *
 * @param data Object containing book details
 * @returns JSON-LD object for schema.org WebPage with Book main entity
 */
export const generateBookJsonLd = (data: BookJsonLdData) => {
  // Base JSON-LD object
  const jsonLd: Record<string, any> = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    mainEntity: {
      '@type': 'Book',
      name: data.name,
      publisher: {
        '@type': 'Organization',
        name: 'Careum',
      },
    },
  }

  const book = jsonLd.mainEntity

  // Add optional properties only if they exist
  if (data.author !== undefined) {
    book.author = data.author
  }

  if (data.bookFormat) {
    book.bookFormat = data.bookFormat
  }

  if (data.datePublished) {
    book.datePublished = data.datePublished
  }

  if (data.image) {
    book.image = data.image
  }

  if (data.inLanguage) {
    book.inLanguage = data.inLanguage
  }

  if (data.isbn) {
    book.isbn = data.isbn
  }

  if (data.numberOfPages) {
    book.numberOfPages = data.numberOfPages
  }

  // Add offers if any price data is available
  if (data.offers) {
    const offers: Record<string, any> = {
      '@type': 'Offer',
    }

    if (data.offers.availability) {
      offers.availability = data.offers.availability
    }

    if (data.offers.price) {
      offers.price = data.offers.price
    }

    if (data.offers.priceCurrency) {
      offers.priceCurrency = data.offers.priceCurrency
    }

    // Only add offers if it has at least one property besides @type
    if (Object.keys(offers).length > 1) {
      book.offers = offers
    }
  }

  return jsonLd
}
